import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { LogOut } from "lucide-react";
import ProfilePage from "@/pages/ProfilePage";

export default function MobileProfile() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  return (
    <div className="max-w-md mx-auto pb-4" data-testid="mobile-profile-page">
      <header className="px-5 pt-6 pb-3">
        <h1 className="font-display text-2xl font-bold text-stone-900">My profile</h1>
        <p className="text-stone-500 text-sm">{user?.email}</p>
      </header>
      <div className="px-3">
        <ProfilePage embedded />
      </div>
      <div className="px-5 mt-3">
        <button onClick={() => { logout(); nav("/login"); }} className="w-full inline-flex items-center justify-center gap-2 px-4 py-3 rounded-xl bg-white border border-stone-200 text-stone-700 font-semibold hover:bg-stone-50" data-testid="mobile-logout">
          <LogOut className="w-4 h-4" />Sign out
        </button>
      </div>
    </div>
  );
}
